import React, { useEffect, useState, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import SideStyle from '../style/sideStyle';
import { AddIcon } from '../formBk/formUtil';
import Param from '../store/param';
import Control from '../store/control';

const FormModeling = () => {
  const style = SideStyle();
  const softInsert = Param.Get('softInsert');
  const setParam = Param.Get('setParam');
  const SetCameraOut = Control.Get('SetCameraOut');
  const prosthetics = Control.Get('prosthetics');

  useEffect(() => {
    //SetCameraOut();
  }, []);

  const handleValue = (e) => {
    setParam(s => {s.softInsert[e.target.name] = Number(e.target.value)});
  };

  return (
    <div className={style.outside}>
      <Grid container direction='row' justifyContent='center' alignItems='center' spacing={2}>
        <TextField
          id='filled-number'
          name='topLineHeight'
          label='Top line height'
          type='number'
          defaultValue={softInsert.topLineHeight}
          fullWidth
          onBlur={handleValue}
          InputProps={{
            endAdornment: <AddIcon unit='mm' helptext='Height from socket bottom'/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{ 
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-1000,
            max:1000,
            step:1
          }}
        />

        <TextField
          id='filled-number'
          name='bottomLineHeight'
          label='Bottom line height'
          type='number'
          defaultValue={softInsert.bottomLineHeight}
          fullWidth
          onBlur={handleValue}
          InputProps={{
            endAdornment: <AddIcon unit='mm' helptext='Height from socket bottom'/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{ 
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:1,
            max:1000,
            step:1
          }}
        />

        {(prosthetics == 'AK') &&
        <TextField
          id='filled-number'
          name='offsetToBottom'
          label='Offset to socket bottom'
          type='number'
          defaultValue={softInsert.offsetToBottom}
          fullWidth
          onBlur={handleValue}
          InputProps={{
            endAdornment: <AddIcon unit='mm' helptext='Height from socket bottom'/>,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{ 
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-1000,
            max:1000,
            step:1
          }}
        />
        }
      </Grid>
    </div>
  );
}
export default FormModeling;
